import { render, staticRenderFns } from "./ModalDeletePhoto.vue?vue&type=template&id=9b0592e4&scoped=true&"
import script from "./ModalDeletePhoto.vue?vue&type=script&lang=js&"
export * from "./ModalDeletePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0592e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b0592e4')) {
      api.createRecord('9b0592e4', component.options)
    } else {
      api.reload('9b0592e4', component.options)
    }
    module.hot.accept("./ModalDeletePhoto.vue?vue&type=template&id=9b0592e4&scoped=true&", function () {
      api.rerender('9b0592e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalDeletePhoto.vue"
export default component.exports